function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 .53C5.68.53.54 5.67.54 11.99c0 6.32 5.14 11.46 11.46 11.46 6.32 0 11.46-5.14 11.46-11.46C23.46 5.67 18.32.53 12 .53zm0 21.73c-5.66 0-10.26-4.6-10.26-10.26S6.34 1.74 12 1.74 22.26 6.34 22.26 12 17.66 22.26 12 22.26z",
  fill: "#F66132"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 9.86c-.33 0-.6.27-.6.6v7.33c0 .33.27.6.6.6.33 0 .6-.27.6-.6v-7.33c0-.33-.27-.6-.6-.6zM12 6c-.554 0-1 .446-1 1s.446 1 1 1 1-.446 1-1-.446-1-1-1z",
  fill: "#F66132"
});

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "1b8f94259a0c52196571d77c0ab8fe98.svg";
export { SvgWarning as ReactComponent };